import PlaceOrderButton from './PlaceOrderButton';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { placeOrder } from '../../stateManagement/engine/actions/CheckoutActions';
import { translate } from 'react-i18next';

function mapStateToProps(state, ownProps) {
  return {
    isWaitingForResponseFromServer: state.checkout.isWaitingForResponseFromServer,
    payments: state.checkout.payments,
    ...ownProps,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      placeOrder,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(PlaceOrderButton));
